// DS9.4.2, DS9.4.2M
import React from 'react';
import { useTranslation } from 'react-i18next';
import PollView from '../../../PollView';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import draftTheme from '../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import optionStyles from './PollOption.scss';
import s from './Poll.scss';
var PollFeedCardContents = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation, extraActions = _a.extraActions, withWatchOrSubscribeButton = _a.withWatchOrSubscribeButton;
    var t = useTranslation().t;
    return (React.createElement(FeedCardLayout, { className: className, deviation: deviation, extraActions: extraActions, withWatchOrSubscribeButton: withWatchOrSubscribeButton, withCommentControl: true },
        React.createElement(FeedCardTitle, { className: s['title'], deviation: deviation, disableScrollRestoration: false }),
        React.createElement("div", { className: s['vote-count'] }, t('pollView.votes', { count: (_b = deviation.poll) === null || _b === void 0 ? void 0 : _b.votes })),
        React.createElement(PollView, { deviation: deviation, hideQuestion: true, draftJsThemeOverride: draftTheme, stylesheet: s, optionImageSize: 32, optionHoverImageSize: 192, optionStylesheet: optionStyles })));
};
PollFeedCardContents.displayName = 'PollFeedCardContents';
export default PollFeedCardContents;
//# sourceMappingURL=Poll.js.map